import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const submitPayrollRun = (axios: IAxiosInstance) => {
  return async (
    requestBody: ISchema["#/definitions/ISubmitPayrollRunRequest"]
  ) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ISubmitPayrollRunResponse"]
    >(`/api/submitPayrollRun`, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData;
    }

    throw new Error("Something went wrong");
  };
};
